<template>
  <div>
    <h6>{{ UNVAN }}</h6>
    <vs-divider style="margin: 0px !important"></vs-divider>
    VD: {{ VD }} <vs-divider style="margin: 0px !important"></vs-divider> Vkn:
    <span style="color: #ea5455">{{ VERGINO }}</span>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      UNVAN: "",
      VD: "",
      VERGINO: "",
    };
  },
  methods: {
    gelenData() {
      this.UNVAN = this.params.data.UNVAN;
      this.VD = this.params.data.VD;
      this.VERGINO = this.params.data.VERGINO;
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
